(function () {

  function cleanFlickityAria(sliderEl) {
    const slides = sliderEl.querySelectorAll('.gallery-cell, [data-slide]');

    slides.forEach(slide => {
      // Remove invalid aria attributes
      slide.removeAttribute('aria-selected');
      slide.removeAttribute('aria-hidden');
    });
  }

  function attachFix(sliderEl) {
    if (!sliderEl || sliderEl.dataset.ariaFixed) return;

    sliderEl.dataset.ariaFixed = "true";

    cleanFlickityAria(sliderEl);

    sliderEl.addEventListener('select.flickity', () => cleanFlickityAria(sliderEl));
    sliderEl.addEventListener('settle.flickity', () => cleanFlickityAria(sliderEl));
    sliderEl.addEventListener('ready.flickity', () => cleanFlickityAria(sliderEl));

    const observer = new MutationObserver(() => {
      cleanFlickityAria(sliderEl);
    });

    observer.observe(sliderEl, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-selected', 'aria-hidden', 'class']
    });
  }

  const documentObserver = new MutationObserver(() => {
    document.querySelectorAll('.flickity-enabled').forEach(attachFix);
  });

  documentObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

})();